import { StylesConfig } from 'react-select';

export const SelectStyles: StylesConfig = {
  control: (styles, { isDisabled }) => ({
    ...styles,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    minHeight: '2.25rem',
    backgroundColor: 'rgb(255 255 255 / var(--tw-bg-opacity))',
    borderRadius: 'calc(var(--radius) - 2px)',
    borderColor: 'hsl(var(--input))',
    height: '2.25rem',
    opacity: isDisabled ? '0.5' : '1',
    pointerEvents: 'auto',
    cursor: isDisabled ? 'not-allowed' : 'default',
    boxShadow:
      'var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), 0 1px 2px 0 rgb(0 0 0 / 0.05)',
    ':hover': {
      borderColor: 'hsl(var(--input))',
    },
  }),
  option: (styles, { isDisabled, isFocused }) => {
    return {
      ...styles,
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      cursor: isDisabled ? 'not-allowed' : 'default',
      color: 'inherit',
      backgroundColor: isFocused ? 'hsl(var(--accent))' : '',
      borderRadius: 'calc(var(--radius) - 2px)',
    };
  },
  menu: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    // backgroundColor: 'rgb(255 255 255 / var(--tw-bg-opacity))',
    borderRadius: 'calc(var(--radius) - 2px)',
    borderColor: 'hsl(var(--input))',
    padding: '1px 1px',
  }),
  placeholder: (styles) => ({
    ...styles,
    color: 'hsl(var(--muted-foreground))',
  }),
  menuList: (styles) => ({
    ...styles,
    '::-webkit-scrollbar': {
      width: '10px',
      height: '42px',
    },
    '::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'hsl(var(--border))',
      borderRadius: '9999px',
    },
  }),
};
